import styles from './ThirdSection.module.css'
import CountryItem from './CountryItem/CountryItem'
// import Footer from './Footer/Footer'
import Popup from './Popup/Popup'
import countries from './countries'
import State from '../../store/State'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

export const ThirdSection = observer(() => {
  const open = State.isCountriesListOpen()
  const sectionActiveClass = open ? styles.active : styles.inactive

  useEffect(() => {
    const setVh = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    };
    setVh();
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    return () => {
      window.removeEventListener('resize', setVh);
      window.removeEventListener('orientationchange', setVh);
    };
  }, [])

  return (<>
    <div className={styles.section + ' ' + sectionActiveClass} id='section3'>
      <div className={open ? styles.blur_right : ''}></div>
      <div className={open ? styles.blur_left : ''}></div>

      <div className={styles.grid}>
        {countries.map((country, i) => {
          return (
            <CountryItem
              key={country.name}
              img={country.card}
              name={country.name}
              index={i}
            />
          )
        })}
      </div>
      <Popup />
      <div className={styles.hr}></div>
    </div>
    {/* <Footer /> */}
  </>)
});

export default ThirdSection
